import Bugsnag from "@bugsnag/js";
import { IMultiOrderOrchestrator } from "@nju/data-access-portal-orchestrator";
import { client } from "@nju/http-client";
import { ok } from "@nju/result";
import { IFetchGroupsResult } from "./types";
import { serverResponse } from "./validators";

export async function fetchGroups(props?: {
  offerCategory?: IMultiOrderOrchestrator["offerCategory"];
  withProducts?: boolean;
}): Promise<IFetchGroupsResult> {
  const offerCategory = props?.offerCategory;
  const withProducts = props?.withProducts;
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/groups`,
    {
      headers: {
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
        version: "2",
      },
      searchParams: {
        hideEmpty: true,
        ...(offerCategory ? { offerCategory } : {}),
        ...(withProducts !== undefined ? { withProducts } : {}),
      },
      validator: serverResponse,
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  const sortedGroups = result.value.map((group) => {
    return {
      ...group,
      members: group.members.sort((a, b) => {
        if (a.primaryMsisdn && !b.primaryMsisdn) {
          return -1;
        } else if (!a.primaryMsisdn && b.primaryMsisdn) {
          return 1;
        } else if (a.primaryMsisdn && b.primaryMsisdn) {
          return 0;
        } else {
          return group.members.indexOf(a) - group.members.indexOf(b);
        }
      }),
    };
  });

  return ok(sortedGroups);
}
